import React from 'react';
import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import { Deal } from '../types/deal';

interface DealStageCardsProps {
  deals: Deal[];
  dealStages: Record<string, string>;
  dealStagesList: string[];
  selectedStage: string | null;
  onStageSelect: (stage: string | null) => void;
}

export const DealStageCards: React.FC<DealStageCardsProps> = ({
  deals,
  dealStages,
  dealStagesList,
  selectedStage,
  onStageSelect,
}) => {
  // Count deals in each stage
  const stageCounts = deals.reduce((acc, deal) => {
    const stage = deal.properties.dealstage;
    acc[stage] = (acc[stage] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2} className='cards'>
        <Grid item xs={6} sm={3} md={2}>
          <Card 
            className={`card ${selectedStage === null ? 'selected' : ''}`}
            sx={{ 
              cursor: 'pointer',
              borderColor: selectedStage === null ? 'primary.main' : 'background.paper',
              borderWidth: selectedStage === null ? 2 : 0,
              borderStyle: 'solid'
            }}
            onClick={() => onStageSelect(null)}
          >
            <CardContent className='card-content'>
              <Typography component="span" noWrap>All Deals</Typography>
              <Typography component="strong">{deals.length || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        {dealStagesList.map((stageId) => 
          <Grid item xs={6} sm={3} md={2} key={stageId}>
            <Card 
              className={`card ${stageId === selectedStage ? 'selected' : ''}`}
              sx={{ 
                cursor: 'pointer',
                color: 'text.primary',
                borderStyle: 'solid'
              }}
              onClick={() => onStageSelect(stageId)}
            >
              <CardContent className='card-content'>
                <Typography component="span" noWrap>{dealStages[stageId]}</Typography>
                <Typography component="strong">{stageCounts[stageId] || 0}</Typography>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}; 
